import React, {useState} from 'react'
import { HeroContainer, HeroBg, HeroLogo, HeroContent, HeroP, ArrowDown, ArrowDownFull, HeroBtnWrapper } from './HeroElements'
import graveyard from '../../images/graveyard.jpg'
import heroLogo from '../../images/SplashLogo.png'
import { Button } from '../ButtonElement.js'

const HeroSection = () => {
  const [hover, setHover] = useState(false)

  const onHover = () => {
    setHover(!hover)
  }

  return (
    <HeroContainer id="home">
      <HeroBg src={graveyard} />
      <HeroContent>
        <HeroLogo src={heroLogo} />
        <HeroP>6666 Bit Monsters randomly generated and stored 100% on the Ethereum Blockchain</HeroP>
        <HeroBtnWrapper>
          <Button 
            to='mint' 
            onMouseEnter={onHover} 
            onMouseLeave={onHover}
            smooth={true}
            duration={500}
            spy={true}
            exact='true'>
            Mint Now! {hover ? <ArrowDownFull /> : <ArrowDown />}
          </Button>
        </HeroBtnWrapper>
      </HeroContent>
      
    </HeroContainer>
  )
}

export default HeroSection
